import React from "react"

import HotTable from "../../utils/hot-table";

class GrantTableComponent extends React.Component {

	render() {

		return (
			<div>
				<HotTable
					ref="table"
					root={(this.props.awarded ? "awarded" : "asked") + "_grants"}
					headers={false}
					data={this.props.data}
					current_year={this.props.current_year}
					ppi={this.props.ppi}
					tableDefinition={this.props.tableDefinition}
					onCustomAction={this.props.onCustomAction}
					onChange={this.props.onChange} 
				/>
			</div>
		)
	}

}

export default GrantTableComponent



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/grants/grant-table-component.js